export const riskFillColours = {
    High: '#F0578A',
    Medium: '#FF9076',
    Low: '#33D1C1'
};

export const riskTextColours = {
    High: '#EC2D6D',
    Medium: '#FF7454',
    Low: '#00C6B2'
};
